module.exports = __webpack_public_path__ + "images/wechat/menu-icon-1c52ea279a524d77e3421207e31ce3e7.png";